<template>
  <div>
    <div
      v-show="theme.isBeenUsedByOtherForms"
      class="Notice Notice--warning"
      style="margin-bottom:10px; padding:5px; font-size: small;"
    >
      <div style="display:flex; justify-content:space-between;">
        <div>
          This theme is in use by other forms:
        </div>
        <div
          style="text-decoration: underline; cursor: pointer"
          @click="ui.relatedForms = !ui.relatedForms"
        >
          {{ (ui.relatedForms) ? 'less info' : 'more info' }}
        </div>
      </div>

      <div
        v-show="ui.relatedForms"
        style="padding-top:10px;"
      >
        <ul style="list-style: circle;margin-left: 25px;margin-bottom: 0">
          <li
            v-for="form in relatedForms"
            :key="form"
            style="color: #a94442;"
          >
            {{ form }}
          </li>
        </ul>
      </div>
    </div>

    <div class="Question-input-type">
      <div class="">
        <label class="ThemeFormLabel"> Name </label>
      </div>

      <div class="Form-field">
        <div class="Form-inputBox">
          <input
            v-model="theme.name"
            type="text"
            placeholder=""
            autocomplete="on"
            class="Form-input"
          >
        </div>
      </div>
    </div>

    <div class="Question-input-type">
      <div class="">
        <label class="ThemeFormLabel"> Font Style </label>
      </div>

      <div class="Form-field">
        <div class="Form-inputBox">
          <rmp-select
            v-model="theme.web_form_theme_font_id"
            class="Form-field--select"
            :items="fonts"
            option-value-key="id"
            option-label-key="name"
          />
        </div>
      </div>
    </div>

    <div class="ThemeFormDivider" />

    <div>
      <label class="ThemeFormGroupLabel"> Form </label>
    </div>

    <div class="Theme-form-container">
      <div class="input-group">
        <label class="ThemeFormLabel">Background</label>
        <div class="ColorSwatch">
          <input
            v-model="theme.form_background"
            class="Color"
            type="color"
          >
          <rmp-input
            v-model="theme.form_background"
            class="Color-value"
          />
        </div>
      </div>

      <div
        v-show="form.type === 'dynamic'"
        class="input-group"
      >
        <label class="ThemeFormLabel">Background Image</label>

        <div
          class="Form-inputBox"
          style="display:flex"
        >
          <div
            class="Icon-s Icon-image"
            type="color"
            style="height: 40px;
              width: 43px;
              padding: 10px;
              border: 1px solid #cccccc;
              border-radius: 3px 0px 0px 3px;"
          />
          <div
            type="color"
            style="height: 40px;
              width: 75px;
              padding: 10px;
              border-right:  1px solid #cccccc;
              border-top:  1px solid #cccccc;
              border-bottom:  1px solid #cccccc;
              margin-right: 5px;
              border-radius: 0 3px 3px 0;"
            @click="$refs.backgroundImageFile.click()"
          >
            Change
            <input
              id="backgroundImageFile"
              ref="backgroundImageFile"
              style="width: 0px;
                visibility: hidden;
                height: 0px;"
              type="file"
              name="headerFilename"
              accept="image/png, image/gif, image/jpeg"
              @change="handleFileUpload($event)"
            >
          </div>
          <div
            class="Icon-s Icon-trash"
            type="color"
            style="
              height: 40px;
              width: 43px;
              padding: 10px;
              border: 1px solid #cccccc;
              border-radius: 3px;
              padding-left: 13px;"
            @click="removeFileUpload()"
          />
        </div>
      </div>
      <div v-show="form.type === 'dynamic'">
        <small style="display: block;margin-bottom: 5px">Background image filename: {{ theme.form_background_image_filename ? theme.form_background_image_filename : 'Not set' }}</small>
        <small style="display: block;">
          The theme background image must be in JPG, PNG or GIF format 1080px / 1040px and less than 10mb.
        </small>
      </div>
    </div>

    <div class="ThemeFormDivider" />

    <div class="">
      <label class="ThemeFormGroupLabel"> Button </label>
    </div>

    <div class="Theme-form-container">
      <div class="input-group">
        <label class="ThemeFormLabel">Background</label>
        <div class="ColorSwatch">
          <input
            v-model="theme.form_button_background"
            class="Color"
            type="color"
          >
          <rmp-input
            v-model="theme.form_button_background"
            class="Color-value"
          />
        </div>
      </div>

      <div class="input-group">
        <label class="ThemeFormLabel">Border Colour</label>
        <div class="ColorSwatch">
          <input
            v-model="theme.form_button_border_colour"
            class="Color"
            type="color"
          >
          <rmp-input
            v-model="theme.form_button_border_colour"
            class="Color-value"
          />
        </div>
      </div>

      <div class="input-group">
        <label class="ThemeFormLabel">Text</label>
        <div class="ColorSwatch">
          <input
            v-model="theme.form_button_text_colour"
            class="Color"
            type="color"
          >
          <rmp-input
            v-model="theme.form_button_text_colour"
            class="Color-value"
          />
        </div>
      </div>
    </div>

    <div class="ThemeFormDivider" />

    <div class="">
      <label class="ThemeFormGroupLabel"> Text </label>
    </div>

    <div class="Theme-form-container">
      <div class="input-group">
        <label class="ThemeFormLabel">Questions</label>
        <div class="ColorSwatch">
          <input
            v-model="theme.form_questions_text_colour"
            class="Color"
            type="color"
          >
          <rmp-input
            v-model="theme.form_questions_text_colour"
            class="Color-value"
          />
        </div>
      </div>

      <div class="input-group">
        <label class="ThemeFormLabel">Answers</label>
        <div class="ColorSwatch">
          <input
            v-model="theme.form_answers_text_colour"
            class="Color"
            type="color"
          >
          <rmp-input
            v-model="theme.form_answers_text_colour"
            class="Color-value"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import RmpInput from '@rmpenterprise/form-input';
import RmpSelect from '@rmpenterprise/form-select';

export default {
  components: {
    RmpInput,
    RmpSelect,
  },
  data() {
    return {
      theme: {
        id: null,
        name: null,
        web_form_theme_font_id: null,
        form_background: null,
        form_background_image_path: null,
        form_background_image_name: null,
        form_button_background: null,
        form_button_border_colour: null,
        form_button_text_colour: null,
        form_answers_text_colour: null,
        form_questions_text_colour: null,
      },
      ui: {
        showRelatedFormsModal: false,
        relatedForms: false,
      },
    };
  },

  computed: {
    ...mapState('themes', {
      editableThemeId: (state) => state.editableThemeId,
      relatedForms: (state) => state.relatedForms,
    }),

    ...mapState('events', {
      fonts: (state) => state.lists.themeFonts,
    }),

    ...mapState('forms', {
      form: (state) => state.form,
    }),

    ...mapGetters('themes', [
      'getEditableThemeById',
    ]),

    fontStyles() {
      return this.fonts.map((font) => font.name);
    },
  },

  watch: {
    theme: {
      handler(theme) {
        this.setPreviewTheme(theme);
      },
      deep: true,
    },
  },

  mounted() {
    if (this.editableThemeId !== null) {
      this.theme = this.getEditableThemeById(this.editableThemeId);
      this.showRelatedForms();
    } else {
      Object.keys(this.theme).forEach((key) => {
        this.theme[key] = null;
      });
      this.setPreviewTheme(this.theme);
    }
  },

  methods: {
    ...mapMutations('themes', [
      'setPreviewTheme',
    ]),

    ...mapActions('themes', [
      'getFormsByThemeId',
    ]),

    handleFileUpload({ currentTarget: input }) {
      if (input.files && input.files[0]) {
        const reader = new FileReader();

        this.theme.form_background_image_filename = input.files[0].name;

        reader.onload = (e) => {
          this.theme.form_background_image_path = e.target.result;
          this.theme.form_background_image_as_base64_string = e.target.result;
        };

        reader.readAsDataURL(input.files[0]); // convert to base64 string
      }
    },

    removeFileUpload() {
      this.theme.form_background_image_path = null;
      this.theme.form_background_image_name = null;
      this.theme.form_background_image_filename = null;
      this.theme.form_background_image_as_base64_string = null;
    },

    showRelatedForms() {
      const payload = {
        themeId: this.theme.id,
        formId: this.$route.params.id,
      };
      this.getFormsByThemeId(payload)
        .catch((data) => {
          this.$bus.$emit('displayMsg', {
            text: data.data.message,
            type: 'error',
            duration: 25000,
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.ThemeFormGroupLabel {
  display: block;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.ThemeFormLabel {
  display: block;
  margin-bottom: 10px;
}

.ThemeFormDivider {
  border: 1px solid lightgray;
  margin: 20px 0 20px 0;
}

.ColorSwatch {
  border: 1px solid #cccccc;
  border-radius: 8px;
  display: flex;
  margin-right: 25px;

  .Color {
    height: 40px;
    width: 43px;
    padding: 0px;
    border: 1px solid #cccccc;

    &:invalid {
      border: 3px solid red;
    }
  }

  .Color-value {
    padding: 0px 32px 0px 11px;
  }

  .Color-value.Form-field {
    margin: 0;
    padding: 0;
  }
}

.Theme-form-container {
  display: flex;
  flex-wrap: wrap;

  .input-group {
    flex-basis: 50%;
    margin-bottom: 10px;
  }
}

.ColorSwatch-container {
  position: absolute;
  top: 129px;
  left: 100px;

  .Icon-s {
    position: absolute;
    display: inline-block;
    top: -21px;
    right: 1px;
    padding: 2px 5px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #cccccc;
  }
}
</style>
